import logo from './logo.svg';
import './App.css';
import Header from './Components/Header';
import styled from 'styled-components';
import Navbar from './Components/Navbar';
import { Routes,Route, useNavigate } from 'react-router-dom';
import Home from './Components/Home';
import Info from './Components/Info';
import Cart from './Components/Cart';
import CartItem from './Components/CartItem';
import { useEffect } from 'react';
import { auth } from './Config';
import User from './Components/User';
function App() {
  let navigate = useNavigate()
  const Container = styled.div`
    display:flex;
  `
  useEffect(()=>{
    if (!auth.currentUser){
      navigate('/')
    }
  },[])
  return (
    <div className="App">
        <Header/>
        <Container>
          <Navbar/>
          <Routes>
            <Route path='' element={<Home/>}/>
            <Route path='info:id' element={<Info/>}/>
            <Route path='cart' element={<Cart/>}/>
            <Route path='cartitem' element={<CartItem/>}/>
            <Route path='user' element={<User/>}/>
          </Routes>
        </Container>
    </div>
  );
}

export default App;
